<template lang="pug">
  .ribbon-wrap
    p.ribbon.upper.semi-bold.xs-f-small.max-at-tweak(v-if="product.inventory_status == 'coming_soon'") coming soon
    p.ribbon.upper.semi-bold.xs-f-small.max-at-tweak(v-else-if="product.inventory_status == 'backordered'") backordered
    p.ribbon.purple.upper.semi-bold.xs-f-small.max-at-tweak(v-else-if="product.new") new

</template>

<script>
  export default {
    name: 'PdpCarouselRibbon',

    props: {
      product: {
        type: Object
      }
    }
  };
</script>

<style scoped lang="stylus">
  .ribbon-wrap
    position absolute
    top 0
    left 0
    width 10em
    height 10em
    overflow hidden

    .ribbon
      position absolute
      transform translate3D(-50%, -50%, 0) rotate(-45deg)
      top 4em
      left 4em
      background-color #d8e3f2
      padding 0.5em 3em
      min-width 15em
      text-align center

      &.purple
        background-color color-mr-purple
        color color-white

</style>